import { useState, useRef } from "react"

import Style from "./style"
import eraseIcon from "./asset/erase.svg"

import MainHeader from "widget/MainHeader"

import ITStyle from "shared/style/inputTableStyle"
import DefaultButton from "shared/ui/DefaultButton"

import CStyle from "shared/style/commonStyle"
import usePostImgUpload from "entity/util/usePostImgUpload"
import usePostImgListUpload from "entity/util/usePostImgListUpload"
import usePostSeries from "entity/series/usePostSeries"

let identifier = 0

const SeriesCreate = () => {
    const nameRef = useRef()
    const startDateRef = useRef()
    const endDateRef = useRef()
    const contentRef = useRef()
    const totalGtdRef = useRef()
    const mainGtdRef = useRef()

    const seedTypeListRef = useRef([])
    const [seedTicketList, setSeedTicketList] = useState([])

    const logoInputRef = useRef()
    const imgInputRef = useRef()

    const [logoFilePath, uploadLogoEvent, deleteLogoImg] = usePostImgUpload()
    const [imgPathList, uploadImgEvent, deleteImg] = usePostImgListUpload(null, 20)
    const [postSeries] = usePostSeries(nameRef, startDateRef, endDateRef, contentRef, seedTypeListRef, totalGtdRef, mainGtdRef, logoFilePath, imgPathList)

    const btnList = [
        {
            "label": "생성",
            "clickEvent": () => postSeries(),
            "deactive": false
        }
    ]

    const createSeedTicketTypeEvent = () => {
        identifier += 1
        const tmpList = [...seedTicketList, identifier]
        setSeedTicketList(tmpList)
    }

    const deleteSeedTicketTypeEvent = (index) => {
        const tmpList = [...seedTicketList]
        tmpList.splice(index, 1)
        setSeedTicketList(tmpList)
    }

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList} />
            <CStyle.GuideDiv>
                <p>전체 GTD, 메인 이벤트 GTD는 사용자들에게 보여주기 위한 데이터로 서비스 내부 로직과는 상관없습니다.</p>
            </CStyle.GuideDiv>

            <ITStyle.TableDiv>
                <ITStyle.TableVerticalElement>
                    <h2>대회 시리즈 이름<span>*</span></h2>
                    <input ref={nameRef} placeholder="40글자 이하" />
                </ITStyle.TableVerticalElement>
                <ITStyle.TableElement>
                    <h2>시작 날짜<span>*</span></h2>
                    <input type="date" ref={startDateRef} />
                </ITStyle.TableElement>
                <ITStyle.TableElement>
                    <h2>종료 날짜<span>*</span></h2>
                    <input type="date" ref={endDateRef} />
                </ITStyle.TableElement>
                <ITStyle.TableElement>
                    <h2>전체 GTD</h2>
                    <input ref={totalGtdRef} placeholder="1이상 숫자" />
                </ITStyle.TableElement>
                <ITStyle.TableElement>
                    <h2>메인 이벤트 GTD</h2>
                    <input ref={mainGtdRef} placeholder="1이상 숫자" />
                </ITStyle.TableElement>
                <ITStyle.TableElement>
                    <h2>본문<span>*</span></h2>
                    <textarea ref={contentRef} />
                </ITStyle.TableElement>
            </ITStyle.TableDiv>

            <Style.AreaDiv>
                <h2>로고 이미지</h2>
                <CStyle.GuideDiv>
                    <p>jpg, png 이미지 | 각 20mb 제한 | 최대 5개 까지 첨부</p>
                    <p>1:1 비율의 이미지에 가장 최적화 되어 있습니다.</p>
                </CStyle.GuideDiv>
                <DefaultButton small fitWidth clickEvent={() => logoInputRef.current.click()}>첨부하기</DefaultButton>
                <input type="file" ref={logoInputRef} onChange={uploadLogoEvent} style={{ display: "none" }} />

                {logoFilePath &&
                    <Style.ImgUploadDiv>
                        <Style.ImgElement>
                            <button onClick={deleteLogoImg}>삭제</button>
                            <img src={logoFilePath} onClick={() => window.open(logoFilePath, "_blank")} />
                        </Style.ImgElement>
                    </Style.ImgUploadDiv>
                }

            </Style.AreaDiv>

            <Style.AreaDiv>
                <h2>이미지 첨부</h2>
                <CStyle.GuideDiv>
                    <p>jpg, png 이미지 | 각 20mb 제한 | 최대 20개 까지 첨부</p>
                    <p>16:9 비율의 이미지에 가장 최적화 되어 있습니다.</p>
                </CStyle.GuideDiv>
                <DefaultButton small fitWidth clickEvent={() => imgInputRef.current.click()}>첨부하기</DefaultButton>
                <input type="file" ref={imgInputRef} onChange={uploadImgEvent} style={{ display: "none" }} />

                {imgPathList.length > 0 &&
                    <Style.ImgUploadDiv>
                        {imgPathList?.map((elem, index) =>
                            <Style.ImgElement>
                                <button onClick={() => deleteImg(index)}>삭제</button>
                                <img src={elem} onClick={() => window.open(elem, "_blank")} />
                            </Style.ImgElement>
                        )}
                    </Style.ImgUploadDiv>
                }
            </Style.AreaDiv>

            <Style.AreaDiv>
                <Style.AreaHeader>
                    <h2>시드권 종류 목록<span>*</span></h2>
                    <DefaultButton small fitWidth clickEvent={createSeedTicketTypeEvent}>항목 추가</DefaultButton>
                </Style.AreaHeader>
                <CStyle.GuideDiv>
                    <p>대회 시리즈에 종속된 공식 대회, 공식 예선전 대회에서 사용되는 시드권 종류 입니다.</p>
                    <p>- 공식 예선전 대회의 프라이즈로 이곳에 기입된 시드권만 지급 가능</p>
                    <p>- 공식 대회 신청에 이곳에 기입된 시드권만 사용 가능</p>
                    <p>이미 만들어진 시드권의 이름 수정은 가능하지만 삭제는 불가능합니다.</p>
                </CStyle.GuideDiv>
                <Style.SeedList>
                    {seedTicketList.map((elem, index) =>
                        <Style.SeedElement key={elem}>
                            <input ref={(childRef) => {
                                if (childRef) seedTypeListRef.current[index] = childRef
                                else seedTypeListRef.current.splice(index, 1)
                            }} />
                            <button onClick={() => deleteSeedTicketTypeEvent(index)}><img src={eraseIcon} /></button>
                        </Style.SeedElement>
                    )}
                </Style.SeedList>
            </Style.AreaDiv>

        </Style.Wrapper >
    )
}

export default SeriesCreate